import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalsoftConfigService } from './config.service';
import { Calsoft_APP_CONFIG } from './config.constants';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class CalsoftConfigModule { 

   /**
     * Constructor
     *
     * @param {CalsoftConfigService} _calsoftConfigService
     */
    constructor(
      private _calsoftConfigService: CalsoftConfigService
  )
  {
  }

  /**
   * forRoot method for setting user configuration
   *
   * @param config
   */
  static forRoot(config: any): ModuleWithProviders<CalsoftConfigModule>
  {
      return {
          ngModule : CalsoftConfigModule,
          providers: [
              {
                  provide : Calsoft_APP_CONFIG,
                  useValue: config
              }
          ]
      };
  }
}
